import styled from 'styled-components';

export const Container = styled.div`
  background: ${({ theme }) => theme.tokens.colors.neutral[300]};
`;

export const Cover = styled.div`
  background: ${({ theme }) => theme.tokens.colors.neutral[800]};
  height: 18rem;
`;

export const UserInfo = styled.div`
  position: relative;
  background: ${({ theme }) => theme.tokens.colors.neutral[100]};
  margin: -2rem auto;
  max-width: 65.5rem;
  padding: 0.75rem 1rem 0.75rem 0;
  border-radius: 6px;
  display: flex;
  align-items: center;
  width: calc(100% - 2rem);
  height: 4rem;
`;

export const Avatar = styled.div`
  background: ${({ theme }) => theme.tokens.colors.neutral[100]};
  border-radius: 50%;
  width: 7.5rem;
  height: 7.5rem;
  margin-left: 1rem;
  border-radius: 50%;
  flex-shrink: 0;
`;

export const Username = styled.div`
  background: ${({ theme }) => theme.tokens.colors.neutral[300]};
  height: 0.75rem;
  width: 9.5rem;
  margin-left: 1rem;
  border-radius: 6px;
`;

export const Content = styled.div<{ $hasTabs?: boolean }>`
  margin: 0 auto;
  padding: 6.25rem 1rem 2rem 1rem;
  max-width: 54rem;
`;

export const Tabs = styled.div`
  background: ${({ theme }) => theme.tokens.colors.neutral[100]};
  height: 1.75rem;
  width: 100%;
  max-width: 27.5rem;
  margin: 0 auto;
  border-radius: 1rem;
`;

export const Grid = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1.5rem;
`;

export const Col = styled.div`
  background: ${({ theme }) => theme.tokens.colors.neutral[100]};
  height: 13.75rem;
  width: 50%;
  border-radius: 6px;
`;
